'use client'

/**
 * Preload critical resources
 */
export function preloadFont(href: string) {
  if (typeof document === 'undefined') return

  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'font'
  link.href = href
  link.crossOrigin = 'anonymous'
  document.head.appendChild(link)
}

export function preloadImage(src: string) {
  if (typeof document === 'undefined') return

  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'image'
  link.href = src
  document.head.appendChild(link)
}

/**
 * Prefetch data for next navigation
 */
export function prefetchData(url: string) {
  if (typeof document === 'undefined') return

  const link = document.createElement('link')
  link.rel = 'prefetch'
  link.href = url
  document.head.appendChild(link)
}

/**
 * Hook pour prefetch au hover
 */
export function usePrefetchOnHover(url: string) {
  if (typeof window === 'undefined') return () => {}

  return () => {
    const link = document.createElement('link')
    link.rel = 'prefetch'
    link.href = url
    document.head.appendChild(link)
  }
}
